"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ShareButton;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_native_1 = require("react-native");
const react_native_fontawesome_1 = require("@fortawesome/react-native-fontawesome");
const pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
const useDevice_1 = require("../../hooks/useDevice");
const AppTooltip_1 = __importDefault(require("../AppTooltip"));
const AppText_1 = require("../AppText");
const colors_1 = require("../../common/colors");
function ShareButton({ style, ...restProps }) {
    const { isMobileScreen, } = (0, useDevice_1.useDevice)();
    const [isHovered, setIsHovered] = (0, react_1.useState)(false);
    const isIconOnly = isMobileScreen;
    return ((0, jsx_runtime_1.jsx)(AppTooltip_1.default, { label: "Share Summary", children: (0, jsx_runtime_1.jsxs)(react_native_1.Pressable, { onHoverIn: () => setIsHovered(true), onHoverOut: () => setIsHovered(false), style: typeof style === 'function'
                ? (state) => [styles.button, style(state)]
                : [styles.button,
                    isIconOnly && {
                        backgroundColor: "transparent",
                        padding: 0,
                        borderColor: "transparent",
                        borderWidth: 0,
                    },
                    !isIconOnly && styles.fullButton,
                    isIconOnly && isHovered && [styles.hoveredButton, { opacity: 0.7 }],
                    !isIconOnly && isHovered && styles.hoveredButton, style], ...restProps, children: [(0, jsx_runtime_1.jsx)(react_native_fontawesome_1.FontAwesomeIcon, { icon: pro_light_svg_icons_1.faShareNodes, color: colors_1.Colors.white, size: isIconOnly ? 24 : 20 }), !isIconOnly && ((0, jsx_runtime_1.jsx)(AppText_1.AppText, { style: styles.text, children: "Share" }))] }) }));
}
;
const styles = react_native_1.StyleSheet.create({
    button: {
        backgroundColor: colors_1.Colors.DARK_700,
        padding: 12,
        borderRadius: 32,
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'row',
        borderWidth: 1,
        borderColor: colors_1.Colors.PRIMARY_300,
    },
    fullButton: {
        minWidth: 100,
        gap: 8,
        backgroundColor: colors_1.Colors.DARK_700,
        borderColor: colors_1.Colors.PRIMARY_300,
    },
    hoveredButton: {
        backgroundColor: colors_1.Colors.PRIMARY_700,
    },
    text: {
        color: colors_1.Colors.white,
        fontSize: 16,
    }
});
